/**
 * Função para coletar informações do dispositivo/navegador do usuário
 * Retorna um objeto com todas as informações disponíveis via navegador
 */
export function getDeviceInfo() {
  const navigator = window.navigator;
  const screen = window.screen;
  
  // Detectar navegador e versão
  const userAgent = navigator.userAgent || '';
  let browser = 'Unknown';
  let browserVersion = 'Unknown';
  let os = 'Unknown';
  let osVersion = 'Unknown';
  
  // Detectar navegador
  if (userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Edg') === -1) {
    browser = 'Chrome';
    const match = userAgent.match(/Chrome\/(\d+)/);
    browserVersion = match ? match[1] : 'Unknown';
  } else if (userAgent.indexOf('Firefox') > -1) {
    browser = 'Firefox';
    const match = userAgent.match(/Firefox\/(\d+)/);
    browserVersion = match ? match[1] : 'Unknown';
  } else if (userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') === -1) {
    browser = 'Safari';
    const match = userAgent.match(/Version\/(\d+)/);
    browserVersion = match ? match[1] : 'Unknown';
  } else if (userAgent.indexOf('Edg') > -1) {
    browser = 'Edge';
    const match = userAgent.match(/Edg\/(\d+)/);
    browserVersion = match ? match[1] : 'Unknown';
  } else if (userAgent.indexOf('Opera') > -1 || userAgent.indexOf('OPR') > -1) {
    browser = 'Opera';
    const match = userAgent.match(/(?:Opera|OPR)\/(\d+)/);
    browserVersion = match ? match[1] : 'Unknown';
  }
  
  // Detectar sistema operacional
  if (userAgent.indexOf('Windows NT') > -1) {
    os = 'Windows';
    const match = userAgent.match(/Windows NT (\d+\.\d+)/);
    if (match) {
      const version = match[1];
      const versionMap = {
        '10.0': '10/11',
        '6.3': '8.1',
        '6.2': '8',
        '6.1': '7',
        '6.0': 'Vista',
        '5.1': 'XP'
      };
      osVersion = versionMap[version] || version;
    }
  } else if (userAgent.indexOf('Mac OS X') > -1) {
    os = 'macOS';
    const match = userAgent.match(/Mac OS X (\d+[._]\d+)/);
    osVersion = match ? match[1].replace('_', '.') : 'Unknown';
  } else if (userAgent.indexOf('Linux') > -1) {
    os = 'Linux';
  } else if (userAgent.indexOf('Android') > -1) {
    os = 'Android';
    const match = userAgent.match(/Android (\d+\.?\d*)/);
    osVersion = match ? match[1] : 'Unknown';
  } else if (userAgent.indexOf('iPhone') > -1 || userAgent.indexOf('iPad') > -1) {
    os = 'iOS';
    const match = userAgent.match(/OS (\d+[._]\d+)/);
    osVersion = match ? match[1].replace('_', '.') : 'Unknown';
  }
  
  // Detectar tipo de dispositivo
  const isMobile = /Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
  const isTablet = /iPad|Android(?!.*Mobile)|Tablet/i.test(userAgent);
  const deviceType = isMobile ? (isTablet ? 'Tablet' : 'Mobile') : 'Desktop';
  
  // Informações de tela
  const screenInfo = {
    width: screen.width || null,
    height: screen.height || null,
    availWidth: screen.availWidth || null,
    availHeight: screen.availHeight || null,
    colorDepth: screen.colorDepth || null,
    pixelDepth: screen.pixelDepth || null,
    orientation: screen.orientation ? {
      angle: screen.orientation.angle || null,
      type: screen.orientation.type || null
    } : null
  };
  
  // Informações do viewport (janela do navegador)
  const viewportInfo = {
    width: window.innerWidth || null,
    height: window.innerHeight || null
  };
  
  // Outras informações
  const otherInfo = {
    language: navigator.language || null,
    languages: navigator.languages || [],
    platform: navigator.platform || null,
    cookieEnabled: navigator.cookieEnabled || false,
    onLine: navigator.onLine !== undefined ? navigator.onLine : null,
    touchSupport: 'ontouchstart' in window || navigator.maxTouchPoints > 0,
    maxTouchPoints: navigator.maxTouchPoints || 0,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || null,
    timezoneOffset: new Date().getTimezoneOffset() || null,
    hardwareConcurrency: navigator.hardwareConcurrency || null,
    deviceMemory: navigator.deviceMemory || null,
    connection: navigator.connection ? {
      effectiveType: navigator.connection.effectiveType || null,
      downlink: navigator.connection.downlink || null,
      rtt: navigator.connection.rtt || null,
      saveData: navigator.connection.saveData || false
    } : null
  };
  
  return {
    userAgent: userAgent,
    browser: {
      name: browser,
      version: browserVersion
    },
    os: {
      name: os,
      version: osVersion
    },
    device: {
      type: deviceType,
      isMobile: isMobile,
      isTablet: isTablet
    },
    screen: screenInfo,
    viewport: viewportInfo,
    ...otherInfo,
    timestamp: new Date().toISOString()
  };
}

